import Api from '@/services/Api'

export default {
  getMessageTypes () {
    return Api().get('/message/types/')
  },
  getBulkRequests (CompanyId) {
    return Api().get('/message/requests/company/' + CompanyId)
  },
  getMessageTemplates (CompanyId) {
    return Api().get('/message/templates/company/' + CompanyId)
  },
  createBulkRequest (data) {
    return Api().post('/message/requests/company/' + data.CompanyId, data)
  },
  removeTemplate (data) {
    return Api().delete('/message/templates/' + data.id + '/company/' + data.CompanyId, data)
  },
  createTemplate (data) {
    return Api().post('/message/templates/company/' + data.CompanyId, data)
  },
}
